<template>
  <div>
    <vue-editor v-model="hotel.note" :editor-toolbar="custom_toolbar" disabled />
    <div class="hotel__wrapper">
      <div class="hotel__part">
        <div class="hotel__name">
          <img src="@/assets/img/personal-details.svg" alt="personal">
          <span>Main info</span>
        </div>
        <div class="hotel__row">
          <app-form-group label="Hotel chain">
            <app-input
                v-model="hotel.chain"
                id="chain"
                placeholder="Hotel chain"
                name="chain"
                readonly
            />
          </app-form-group>
          <app-form-group label="Type">
            <app-input
                v-model="hotel.type.name"
                id="type"
                placeholder="Type"
                name="type"
                readonly
            />
          </app-form-group>
        </div>
        <div class="hotel__row">
          <app-form-group label="Territory">
            <app-input
                v-model="hotel.territory.name"
                id="territory"
                placeholder="Territory"
                name="territory"
                readonly
            />
          </app-form-group>
          <app-form-group label="Region">
            <app-input
                v-model="hotel.region.name"
                id="region"
                placeholder="Region"
                name="region"
                readonly
            />
          </app-form-group>
          <app-form-group label="Area">
            <app-input
                v-model="hotel.area.name"
                id="area"
                placeholder="Area"
                name="area"
                readonly
            />
          </app-form-group>
        </div>
        <div class="hotel__row">
          <app-form-group label="Closest Airport / Airstrip">
            <app-input
                v-model="hotel.airport.name"
                id="closest"
                placeholder="Closest Airport / Airstri"
                name="closest"
                readonly
            />
          </app-form-group>
          <app-form-group label="Transfer time">
            <app-input
                v-model="hotel.airport_transfer_time"
                id="airport_transfer_time"
                placeholder="Transfer time"
                name="airport_transfer_time"
                readonly
            />
          </app-form-group>
        </div>
      </div>
      <div class="hotel__part">
        <div class="hotel__name">
          <img src="@/assets/img/personal-details.svg" alt="personal">
          <span>Conditions</span>
        </div>
        <div class="hotel__row">
          <app-form-group label="Check-in">
            <app-input
                v-model="hotel.check_in"
                id="check_in"
                placeholder="Check-in"
                name="check_in"
                readonly
            />
          </app-form-group>
          <app-form-group label="Check-out">
            <app-input
                v-model="hotel.check_out"
                id="check_out"
                placeholder="Check-out"
                name="check_out"
                readonly
            />
          </app-form-group>
        </div>
        <div class="hotel__row hotel__row--full">
          <app-form-group label="Meal plan type" required>
            <app-select v-model="hotel.meal_plans" :clearable="false" placeholder="Meal plan type" multiple readonly />
          </app-form-group>
          <app-form-group label="Amenities" required>
            <app-select v-model="hotel.amenities" :clearable="false" placeholder="Amenities" multiple readonly />
          </app-form-group>
        </div>
      </div>
      <div class="hotel__part">
        <div class="hotel__name">
          <img src="@/assets/img/personal-details.svg" alt="personal">
          <span>External</span>
        </div>
        <div class="hotel__row">
          <app-form-group label="Website">
            <app-input
                v-model="hotel.website"
                id="website"
                placeholder="Website"
                name="website"
                readonly
            />
          </app-form-group>
        </div>
        <div class="hotel__row">
          <app-form-group label="Booking">
            <app-input
                v-model="hotel.booking"
                id="booking"
                placeholder="Booking"
                name="booking"
                readonly
            />
          </app-form-group>
          <app-form-group label="Booking rating">
            <app-input
                v-model="hotel.booking_rating"
                id="booking_rating"
                placeholder="Booking rating"
                name="booking_rating"
                readonly
            />
          </app-form-group>
        </div>
        <div class="hotel__row">
          <app-form-group label="Tripadvisor">
            <app-input
                v-model="hotel.tripadvisor"
                id="tripadvisor"
                placeholder="Tripadvisor"
                name="tripadvisor"
                readonly
            />
          </app-form-group>
          <app-form-group label="Tripadvisor rating">
            <app-input
                v-model="hotel.tripadvisor_rating"
                id="tripadvisor_rating"
                placeholder="Tripadvisor rating"
                name="tripadvisor_rating"
                readonly
            />
          </app-form-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  name: 'HotelsDatabaseDetailGeneral',
  components: { VueEditor },
  props: {
    hotel: {
      type: Object,
    },
  },
  data() {
    return {
      custom_toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        ['clean']
      ]
    }
  },
}
</script>
<style lang="sass" scoped>
.hotel__wrapper
  max-width: 1080px
  margin-top: 20px

  +max-w($laptop_md)
    max-width: 100%

.hotel__name
  display: flex
  align-items: center
  gap: 10px
  margin-bottom: 25px
  color: #181818
  font-weight: 500

.hotel__name--no-indent
  margin-bottom: 0

.hotel__part
  margin-bottom: 20px

.hotel__part--more-indent
  margin-bottom: 40px

.hotel__row
  display: grid
  gap: 10px 20px
  grid-template-columns: repeat(3, 1fr)
  margin-bottom: 20px

.hotel__row--double
  grid-template-columns: 420px

.hotel__row--full
  grid-template-columns: 1fr

</style>
